// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper[data-v-70464efd]{border-radius:.5rem;overflow:hidden}.image[data-v-70464efd]{display:block;height:16rem;-o-object-fit:cover;object-fit:cover;-o-object-position:right;object-position:right;width:100%}@media(max-width:config(\"theme.screens.md\")){.image[data-v-70464efd]{height:175px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
